import React from 'react'
import PropTypes from 'prop-types'

import { Chip } from '@aok/ui-elements'

import M047QuestionLayout from '../M047QuestionLayout/M047QuestionLayout'
import defaultProps from '../../../../utils/propTypes/defaultProps'

const M047MultiSelectionChip = ({
  headline,
  subtitle,
  options,
  navigateToNextPage,
  navigateToPreviousPage,
  onChangeCallback,
}) => {
  const hasSelectedValue = options?.some((option) => option.selected === true)

  const handleChipClick = (value) => {
    const updatedOptions = options.map((option) => {
      if (value === option.text) {
        return { ...option, selected: !option.selected }
      } else {
        return option
      }
    })

    onChangeCallback(updatedOptions)
  }

  return (
    <M047QuestionLayout
      headline={headline}
      subtitle={subtitle}
      onNextButtonClick={navigateToNextPage}
      onPreviousButtonClick={navigateToPreviousPage}
      nextButtonDisabled={!hasSelectedValue}
    >
      <fieldset className="flex flex-row flex-wrap gap-16">
        <legend className="sr-only">{headline?.text}</legend>
        {options?.map((option) => (
          <Chip
            key={option?.id}
            title={option.text}
            hideCloseButtonWhenInactive
            backgroundVariant="structure"
            size="large"
            value={option.text}
            onClick={handleChipClick}
            isActive={option.selected}
            showCloseButton={false}
          />
        ))}
      </fieldset>
    </M047QuestionLayout>
  )
}

M047MultiSelectionChip.propTypes = {
  headline: PropTypes.shape({
    text: PropTypes.string,
    tag: PropTypes.string,
  }),
  subtitle: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      weight: PropTypes.number,
      selected: PropTypes.bool,
    })
  ),
  navigateToNextPage: PropTypes.func,
  navigateToPreviousPage: PropTypes.func,
  onChangeCallback: PropTypes.func,
}

M047MultiSelectionChip.defaultProps = {
  headline: {
    text: defaultProps.HEADLINE,
  },
  options: [],
  navigateToNextPage: () => {},
  navigateToPreviousPage: () => {},
  onChangeCallback: () => {},
}

export default M047MultiSelectionChip
